import React, { useContext } from 'react';
import { withStyles } from '@material-ui/core/styles';

import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import Day from './Day';

// import cx from 'clsx';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _range from 'lodash/range';
import _filter from 'lodash/filter';

const styles = theme => ({
    root: {
        display: 'flex',
        width: '100%',
        borderBottom: '1px solid #F0F0F0',
        flex: '1 1 auto',
    },
});

const getDefns = params => {
    const { props, calendarData } = params;
    const { classes, id, interviewList = [] } = props;

    const dayIdxList = _range(7);
    const dayList = _map(dayIdxList, idx => {
        return _get(calendarData, `${id}.dayIds[${idx}]`);
    });

    const d0InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d0') >= 0);
    const d1InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d1') >= 0);
    const d2InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d2') >= 0);
    const d3InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d3') >= 0);
    const d4InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d4') >= 0);
    const d5InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d5') >= 0);
    const d6InterviewList = _filter(interviewList, item => _get(item, 'dayId', '').indexOf('d6') >= 0);

    let defns = {
        day0: {
            id: dayList[0],
            interviewList: d0InterviewList,
        },
        day1: {
            id: dayList[1],
            interviewList: d1InterviewList,
        },
        day2: {
            id: dayList[2],
            interviewList: d2InterviewList,
        },
        day3: {
            id: dayList[3],
            interviewList: d3InterviewList,
        },
        day4: {
            id: dayList[4],
            interviewList: d4InterviewList,
        },
        day5: {
            id: dayList[5],
            interviewList: d5InterviewList,
        },
        day6: {
            id: dayList[6],
            interviewList: d6InterviewList,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const Week = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    const context = useContext(LayoutContext);
    const calendarData = _get(context, 'calendarData');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const id = _get(props, 'id');
    const isHidden = _get(props, 'isHidden');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    // const dayIdxList = _range(7);
    // const dayList = _map(dayIdxList, idx => {
    //     return _get(calendarData, `${id}.dayIds[${idx}]`);
    // });
    // const day0Id = _get(calendarData, `${id}.dayIds[0]`);
    // const day1Id = _get(calendarData, `${id}.dayIds[1]`);
    // const day2Id = _get(calendarData, `${id}.dayIds[2]`);
    // const day3Id = _get(calendarData, `${id}.dayIds[3]`);
    // const day4Id = _get(calendarData, `${id}.dayIds[4]`);
    // const day5Id = _get(calendarData, `${id}.dayIds[5]`);
    // const day6Id = _get(calendarData, `${id}.dayIds[6]`);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props, calendarData });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    if (isHidden) {
        return null;
    } else {
        return (
            <LayoutContext.Provider value={{ ...context }}>
                <div {...defns.root} id={id}>
                    <Day {...defns.day0} />
                    <Day {...defns.day1} />
                    <Day {...defns.day2} />
                    <Day {...defns.day3} />
                    <Day {...defns.day4} />
                    <Day {...defns.day5} />
                    <Day {...defns.day6} />
                </div>
            </LayoutContext.Provider>
        );
    }
    //---------------------------------------------------------------------
};

export default withStyles(styles)(Week);
